import { queryify } from '@bingads-webui/url-util';
import { withDFMCache } from '@bingads-webui/dfm-cache';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import { getProductScopeData } from '@bingads-webui-campaign-react/product-services';

export function getProductData({
  cid,
  aid,
  uid,
}) {
  const url = queryify('/Campaign/NewCampaign/GetProductScope', {
    cid,
    aid,
    uid,
  });

  return jsdata.Product.find('MetaData', {
    url,
    adapter: 'legacy',
    bypassCache: false,
    cacheResponse: true,
  });
}

export const getProductScopeFromOData = (serverContext) => {
  const options = {
    dataName: 'MetaData',
    bypassCache: false,
    cacheResponse: true,
    getSalesCountryCollection: true,
    noBMCAccounts: true,
  };

  const p$GetProductData = () => getProductScopeData(null, serverContext, options);
  const getProductDataWithCache = withDFMCache(p$GetProductData, 'getPmaxProductScopeDFM', {}, false);

  return getProductDataWithCache();
};
